import './utils/jquery';
import 'jquery-trend';
import 'jquery-revealer';

import scriptjs from 'scriptjs';
import RimgShopify from '@pixelunion/rimg-shopify';
import ShopifySectionsManager from '@pixelunion/shopify-sections-manager';
import PxsMap from '@pixelunion/pxs-map';
import PxsVideo from 'pxs-video';

import TemplateAccount from './templates/TemplateAccount';
import TemplateAddresses from './templates/TemplateAddresses';

import DynamicBlogPosts from './sections/DynamicBlogPosts';
import DynamicImagesWithText from './sections/DynamicImagesWithText';
import DynamicTestimonial from './sections/DynamicTestimonial';
import StaticAnnouncementBar from './sections/StaticAnnouncementBar';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticFooter from './sections/StaticFooter';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from './sections/StaticHeader';
import StaticPassword from './sections/StaticPassword';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticSearch from './sections/StaticSearch';
import StaticSlideshow from './sections/StaticSlideshow';

import Accordion from './components/Accordion';
import StaticProduct from './sections/StaticProduct';
import RTE from './components/RTE';
import Select from './components/Select';
import Video from './components/Video';

import ThemeUtils from './utils/ThemeUtils';
import polyfillUrls from './utils/checkPolyfills';

// Flickity iOS fix
import flickityTouchFix from './utils/FlickityTouchFix';

RimgShopify.init('[data-rimg="lazy"]', { round: 1 });

const initLaunch = () => {
  const $body = $(document.body);
  const themeUtils = ThemeUtils;
  const isPassword = document.body.classList.contains('template-password');

  const rteViews = [];

  if (!isPassword) {
    $('.rte').map(rte => rteViews.push(new RTE({ el: rte })));
  }

  themeUtils.externalLinks($(document));

  const sections = new ShopifySectionsManager();
  const $scripts = $('[data-scripts]');

  sections.register('static-cart', section => new StaticCart(section));
  sections.register('static-collection', section => new StaticCollection(section));
  sections.register('static-footer', section => new StaticFooter(section));
  sections.register('static-giftcard', section => new StaticGiftCard(section));
  sections.register('static-header', section => new StaticHeader(section));
  sections.register('static-password', section => new StaticPassword(section));
  sections.register('static-product', section => new StaticProduct(section));
  sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
  sections.register('static-search', section => new StaticSearch(section));
  sections.register('static-slideshow', section => new StaticSlideshow(section), { lazy: true });

  sections.register('pxs-announcement-bar', section => new StaticAnnouncementBar(section));
  sections.register('pxs-map', section => new PxsMap(section), { lazy: true });
  sections.register('pxs-video', section => new PxsVideo(section), { lazy: true });
  sections.register('dynamic-alternating-content', section => new Video(section), { lazy: true });
  sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section), { lazy: true });
  sections.register('dynamic-featured-product', section => new StaticProduct(section), { lazy: true });
  sections.register('dynamic-images-with-text', section => new DynamicImagesWithText(section), { lazy: true });
  sections.register('dynamic-testimonials', section => new DynamicTestimonial(section), { lazy: true });
  sections.register('faq', section => new Accordion(section), { lazy: true });

  if ($('select').length) {
    $('select').each((index, item) => new Select({ el: $(item) }));
  }

  if ($(document.body).hasClass('template-customers-addresses')) {
    scriptjs(
      [
        $scripts.data('shopify-common'),
        $scripts.data('shopify-api-url'),
        $scripts.data('customer-area'),
      ], () => {
        scriptjs($scripts.data('shopify-countries'), () => {
          new TemplateAddresses({ el: $body });
        });
      });
  }

  if ($(document.body).hasClass('template-customers-login')) {
    new TemplateAccount({ el: $body });
  }
};

flickityTouchFix();
if (polyfillUrls.length) {
  scriptjs(polyfillUrls, initLaunch);
} else {
  initLaunch();
}
